window.addEventListener("DOMContentLoaded", () => {
  class pqCustomerStory2 extends HTMLElement {
    constructor() {
      super();
      // 初始化元素引用
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      let swiperDom = this.querySelector(".swiper");
      let nextDom = this.querySelector(".pq-customer-story-2_next");
      let prevDom = this.querySelector(".pq-customer-story-2_prev");
      var swiper = new Swiper(swiperDom, {
        navigation: {
          nextEl: nextDom,
          prevEl: prevDom,
        },
        breakpoints: {
          1025: {
            slidesPerView: 1,
          },
          481: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
          0: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
      });
    }
  }
  // 注册自定义元素
  customElements.define("pq-customer-story-2", pqCustomerStory2);
});
